export enum LDRecommendedGamesVariant {
    ControlVariant = 'Control ~ Recommended Games Not Visible',
    TestVariantA = 'Var A ~ Recommended Games Visible 2nd Position',
    TestVariantB = 'Var B ~ Recommended Games Visible 3rd Position',
}

export const LDShowRGFlagDefaultValue = 'No Visibility Change';

export const LaunchDarklyShowRGKey = 'ld1-recommended_games_placement_sportingbet_brazil';

export const LDRecommendedGamesVariantMap = new Map<string, number>([
    [LDRecommendedGamesVariant.ControlVariant, -1],
    [LDRecommendedGamesVariant.TestVariantA, 1],
    [LDRecommendedGamesVariant.TestVariantB, 2],
]);
